import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SharedService } from '../../../../Services/shared.service';
import { API_End_Point } from '../../../../Services/API_End_Point';
import { CommonModule } from '@angular/common';
import { any } from '@tensorflow/tfjs';
import { FormsModule } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs';

@Component({
  selector: 'app-my-mock-test',
  standalone: true,
  imports: [RouterModule, CommonModule, FormsModule],
  templateUrl: './my-mock-test.component.html',
  styleUrl: './my-mock-test.component.css'
})
export class MyMockTestComponent {
  DataList: any = [];
  DataList_Pres: any = [];
  SubjectList: any[] = [];
  // Subject: any = "";
  IsShowMessage: boolean = false;
  PREP_UserInfo: any;
  Subject: string = "All";
  constructor(public _svc: SharedService,
    private _router: Router
  ) { }
  ngOnInit(): void {
    this._svc.get_Login_Status().pipe(distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)))
      .subscribe(x => {
        this.PREP_UserInfo = x;
        this.MyMocTest();
      });

  }

  MyMocTest(): void {
    this.IsShowMessage = false;
    this.SubjectList = [];
    this.DataList = [];
    this._svc.GET(API_End_Point.MyMockTest).subscribe((res) => {
      if (res.result === 'success') {
        this.DataList_Pres = (res.data || []).filter((x: any) => x.ClassId == this.PREP_UserInfo.classId);
        if (this.DataList_Pres.length > 0) {
          this.SubjectList = this._svc.uniqueBy(this.DataList_Pres, "SubjectName");
          // this.Subject = this.SubjectList[0].SubjectName;
          this.Subject = "All";
          this.Subject_Changed();
        } else
          this.IsShowMessage = true;
      }
    });
  }

  Process(_obj: any) {
    debugger
    localStorage.setItem('PREP_ExamDetails', JSON.stringify({ ChildId: this.PREP_UserInfo.childId, SubjectName: _obj.SubjectName, eventLetter: _obj.EventLetter, classId: _obj.ClassId, MockSet: _obj.MockTest, className: this.PREP_UserInfo.className }));
    this._router.navigate(['/required-configuration']);
  }

  Subject_Changed() {
    if (this.Subject === "All") {
      this.DataList = this.DataList_Pres;
    } else {
      this.DataList = this.DataList_Pres.filter((x: any) => x.SubjectName === this.Subject);
    }
  }

  Switch_Child() {
    this._svc.Switch_Child().then((res: any) => {
      this.ngOnInit();
    })
  }
}
